import { render, staticRenderFns } from "./MyVoice.vue?vue&type=template&id=20a69b09&scoped=true&"
import script from "./MyVoice.vue?vue&type=script&lang=ts&"
export * from "./MyVoice.vue?vue&type=script&lang=ts&"
import style0 from "./MyVoice.vue?vue&type=style&index=0&id=20a69b09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a69b09",
  null
  
)

export default component.exports